import * as React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image'

interface ImageQueryData {
	logo: {
		childImageSharp: {
			gatsbyImageData: IGatsbyImageData;
		}
	}
}

const Logo: React.FC = () => {
	const data = useStaticQuery<ImageQueryData>(graphql`
		query NavbarLogoQuery {
			logo: file(relativePath: { eq: "nav/health-at-work-logo.png" }) {
				childImageSharp {
					gatsbyImageData(
						placeholder: NONE
						layout: CONSTRAINED
					)
				}
			}
		}
	`)

	const logo = getImage(data.logo)

	return (
		<Link to="/">
			<GatsbyImage
				image={ logo as IGatsbyImageData }
				alt="Health at Work"
				loading="eager"
				className="h-10 w-40.5"
			/>
		</Link>
	)
}

export default Logo
